import script from "./PublishToYoutube.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishToYoutube.vue?vue&type=script&setup=true&lang=js"

import "./PublishToYoutube.vue?vue&type=style&index=0&id=0ab0a97d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab0a97d"]])

export default __exports__